// src/components/.../toolbar-tabs.tsx
import { getForm } from "@/api/form";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";



import { cn } from "@/lib/utils";



import DeleteForm from "@/components/widget/editor/delete-form";
import SaveForm from "@/components/widget/editor/save-form";
import Copy from "@/components/widget/editor/toolbar-buttons/copy";
import Paste from "@/components/widget/editor/toolbar-buttons/paste";



import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";



import DesignTab from "./tabs/design";
import HomeTab from "./tabs/home";
import HtmlTab from "./tabs/html";
import InsertTab from "./tabs/insert";
import LayoutTab from "./tabs/layout";
import ViewTab from "./tabs/view";


interface Props extends React.ComponentProps<"div"> {
  editorRef: React.RefObject<HTMLDivElement>;
  onHtmlModeChange?: (active: boolean) => void;
  htmlDraft?: string;
  onSaveHtml?: (s: string) => void;
  onResetHtml?: () => void;
}

const ToolbarTabs: React.FC<Props> = ({
  editorRef,
  className,
  onHtmlModeChange,
  htmlDraft,
  onSaveHtml,
  onResetHtml
}) => {
  const { formId } = useParams<{ formId: string }>();
  const { data:formData } = useQuery({
    queryKey: ["form", formId],
    queryFn: () => getForm(Number(formId)),
    enabled: !!formId
  });

  return (
    <Tabs
      defaultValue="home"
      onValueChange={(val) => {
        if (onHtmlModeChange) onHtmlModeChange(val === "html");
      }}
      className="sticky top-0 z-50"
    >
      <div
        className={cn("flex h-12 items-center bg-[#D8E7F4] px-5", className)}
      >
        <TabsList>
          <TabsTrigger
            value="home"
            className="border-b border-b-transparent data-[state=active]:border-b-black"
          >
            Home
          </TabsTrigger>
          <TabsTrigger
            value="insert"
            className="border-b border-b-transparent data-[state=active]:border-b-black"
          >
            Insert
          </TabsTrigger>
          <TabsTrigger
            value="design"
            className="border-b border-b-transparent data-[state=active]:border-b-black"
          >
            Design
          </TabsTrigger>
          <TabsTrigger
            value="layout"
            className="border-b border-b-transparent data-[state=active]:border-b-black"
          >
            Layout
          </TabsTrigger>
          <TabsTrigger
            value="html"
            className="border-b border-b-transparent data-[state=active]:border-b-black"
          >
            HTML
          </TabsTrigger>
          <TabsTrigger
            value="view"
            className="border-b border-b-transparent data-[state=active]:border-b-black"
          >
            View
          </TabsTrigger>
          <TabsTrigger
            value="help"
            className="border-b border-b-transparent data-[state=active]:border-b-black"
          >
            Help
          </TabsTrigger>
        </TabsList>
        <h3 className="ms-auto font-semibold">{formData?.name}</h3>
      </div>
      <div className="flex h-16 w-full items-center overflow-x-auto whitespace-nowrap border-b border-b-slate-200 bg-white px-8">
        <TabsContent value="home">
          <HomeTab editorRef={editorRef} />
        </TabsContent>
        <TabsContent value="insert">
          <InsertTab editorRef={editorRef} />
        </TabsContent>
        <TabsContent value="view">
          <ViewTab editorRef={editorRef} />
        </TabsContent>
        <TabsContent value="layout">
          <LayoutTab editorRef={editorRef} />
        </TabsContent>
        <TabsContent value="design">
          <DesignTab editorRef={editorRef} />
        </TabsContent>
        <TabsContent value="html">
          <HtmlTab
            editorRef={editorRef}
            htmlDraft={htmlDraft ?? ""}
            onSave={onSaveHtml!}
            onReset={onResetHtml!}
          />
        </TabsContent>

        <div className="ms-auto flex items-center gap-x-2">
          <Paste editorRef={editorRef} />
          <Copy editorRef={editorRef} />
          <DeleteForm />
          <SaveForm editorRef={editorRef} />
        </div>
      </div>
    </Tabs>
  );
};
export default ToolbarTabs;